module.exports = __webpack_public_path__ + "static/media/info.e3867532.svg";